import type { Novidade } from './tipos';

/** Fase 2 (W27): e-mails do sistema no padrão do ERP antigo e os avisos de segurança da conta por e-mail. */
export const novidadeEmails: Novidade = {
  id: '2026-10-05-emails',
  publicada_em: '2026-10-05',
  tipo: 'melhoria',
  modulo: null,
  permissao: null,
  textos: {
    pt: {
      titulo: 'E-mails no padrão Malgo',
      resumo: 'Convite, senha, cobrança, holerite e avisos com o visual do ERP antigo, e avisos de segurança da conta por e-mail.',
      passos: [
        'Convite, recuperação de senha, cobrança, holerite e avisos chegam com o layout da Malgo (ou com a logo e a cor da marca do workspace).',
        'Você recebe um e-mail quando a senha muda, quando a verificação em duas etapas é ativada, desativada ou redefinida e quando a conta entra de um aparelho novo.',
        'A cobrança por e-mail usa o modelo de Configurações > Modelos, com o assunto e o texto que você definir.',
      ],
    },
    en: {
      titulo: 'E-mails in the Malgo style',
      resumo: 'Invitation, password, collection, payslip and notices with the old ERP look, plus account security alerts by e-mail.',
      passos: [
        'Invitation, password recovery, collection, payslip and notices arrive with the Malgo layout (or the workspace brand logo and color).',
        'You get an e-mail when your password changes, when two-step verification is turned on, off or reset and when your account signs in from a new device.',
        'Collection e-mails use the template in Settings > Templates, with the subject and text you define.',
      ],
    },
    es: {
      titulo: 'Correos con el estilo Malgo',
      resumo: 'Invitación, contraseña, cobro, recibo de sueldo y avisos con el estilo del ERP anterior, y alertas de seguridad por correo.',
      passos: [
        'Invitación, recuperación de contraseña, cobro, recibo de sueldo y avisos llegan con el diseño de Malgo (o con el logo y el color de la marca del workspace).',
        'Recibes un correo cuando cambia tu contraseña, cuando la verificación en dos pasos se activa, se desactiva o se restablece y cuando tu cuenta entra desde un dispositivo nuevo.',
        'El cobro por correo usa la plantilla de Configuración > Plantillas, con el asunto y el texto que definas.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-emails/convite.webp', '/novidades/2026-10-05-emails/seguranca.webp', '/novidades/2026-10-05-emails/cobranca.webp'],
  treinamento: { curso: 'novidades' },
  rota: '/conta/seguranca',
};
